<template>
    <div>
        <el-tag size="mini" :class="{'need-complate':homeworkType==1,'practice':homeworkType==2}">{{homeworkType==1?'要求完成':'仅供练习'}}</el-tag>
    </div>
</template>

<style lang="scss" scoped>
.need-complate {
    background-color: #d5edda;
    color: #185626;
    border: 1pt solid #acd4b6;
    font-size: 10px;
}

.practice {
    background-color: #dbeffb;
    color: #2e74b6;
    border: 1pt solid #a9c2e3;
    font-size: 10px;
}
</style>

<script>
export default {
    props: {
        data: {},
    },
    data() {
        return {
            homeworkType: '',
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            if (!!this.data) {
                this.homeworkType = this.data.HomeworkType;
            }
        }
    },
    watch: {
        data: function() {
            this.init();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/homeworkTypeCell.vue